import { ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import React, { useEffect, useMemo, useState } from 'react';
import { LoadContacts, LoadCustomAttributeDefinitions, LoadGroups, LoadMessages, LoadSettings, LoadUsers, UpdateContactsMassActionDeletionStatus } from "../../actions";
import { Contact, ContactCustomAttribute, ConversationModel, Group } from '../../models/conversations';
import { PhoneNumberModel, PhoneNumberStatus } from '../../models/phone-number.model';
import { ProfileModel } from '../../models/profile.model';
import { Setting } from '../../models/settings-model';
import { UtilityService } from '../../services/UtilityService';
import SendMessage from "../conversations/send-message-component";
import { ActionLabels, ContactsMassAction, DialogHeaders, GridStatusLabelVariant, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles } from '../shared/constants';
import GridComponent from '../shared/grid';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { AvatarRenderer } from '../shared/grid/avatarRenderer';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import ContactViewComponent from "./contact-view.component";
import { Checkbox, Dialog, DialogContent, DialogTitle, Grid, Popover, Tooltip } from "@mui/material";
import _ from 'lodash';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import PullToRefresh from "react-simple-pull-to-refresh";
import { exportToExcel } from "../../helpers/ExportToExcel";
import { setHeaderTitle, setRefreshHandler, setHeaderCount, setSelectedCount } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { AddContactIcon, BlockIcon, CancelIcon, DisableHorizontalIcon, EditContactIcon, ImportContactIcon, SendIcon, ShareContactIcon, TimmerIcon, TrashIcon, MultiSelectSendIcon, MultiSelectGroupIcon, MultiSelectShareIcon, MultiSelectBlockIcon, MultiSelectDeleteIcon, MultiSelectCrossIcon, MultiSelectUnblockIcon, DownloadedIcon } from "../../icon";
import { UserModel } from '../../models/users.model';
import * as selector from '../../selectors/selectors';
import { ContactService } from "../../services/ContactService";
import { SettingsService } from "../../services/SettingsService";
import { AppRoutes } from "../routes/route.path";
import ConfirmDialog from "../shared/confirm-dialog.component";
import FilterComponent from '../shared/filters/filter.component';
import { CustomFilterCategory } from '../shared/filters/filter.model';
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { HeaderTemplate, dateComparator } from "../shared/grid/grid.services";
import PageHeaderComponent from "../shared/page-header.component";
import SelectPhoneNumbers from "../shared/select-phonenumbers/select-phonenumbers.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import { Link, useNavigate } from 'react-router-dom';
import { UserService } from '../../services/UserService';
import EditGroupComponent from '../groups/edit-group.component';
import Avatar from '../shared/avatar.component';
import ImportExcel from "./importExcel";

interface IProps { }

const ContactsComponent = (props: IProps) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const Groups: Group[] = useSelector(selector.groups)
	const Contacts: Contact[] = useSelector(selector.contacts)
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const Settings: Setting[] = useSelector(selector.settings)
	const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
	const CurrentUser: ProfileModel = UserService.getCurrentUserFromLocalStorage()
	const IsMassDeletionInProgress: boolean = useSelector(selector.isMassDeletionInProgress)
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)
	// const SyncingContacts: OutLookResponse = useSelector(selector.syncingContacts)
	const Allusers: UserModel[] = useSelector(selector.allUsers)
	const CustomAttributeDefinitions = useSelector(selector.customAttributeFields)
	const [showEdit, setShowEdit] = useState<boolean>(false);
	const [contactToEdit, setContactToEdit] = useState<Contact>();
	const [mobileMenu, setMobileMenu] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [checkedContacts, setCheckedContacts] = useState<Contact[]>();
	const [clickRowId, setClickRowId] = useState<string | null>("");
	const [contactName, setContactName] = useState<string>("");
	const [contactID, setContactID] = useState<string>("");
	const [open, setOpen] = useState<boolean>(false);
	const [openShareContact, setOpenShareContact] = useState<boolean>(false);
	const [shareContactId, setShareContactId] = useState<string[]>();
	const [shareContactLoading, setShareContactLoading] = useState<boolean>(false);
	const [gridApi, setGridApi] = useState<any>();
	const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false);
	const [show, setShow] = useState<boolean>(false);
	const [text, setText] = useState<string>("");
	const [dialogAction, setDialogAction] = useState<string | null>("");
	const [buttonName, setButtonName] = useState<string>("");
	const [anchorEl, setAnchorEl] = useState<any>();
	const [openMassAction, setOpenMassAction] = useState<boolean>(false);
	const [groupContactCount, setGroupContactCount] = useState<number>(1);
	const [columnApi, SetColumnApi] = useState<any>(null)
	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
	const [appliedfilters, setappliedfilters] = useState<Contact[]>([]);
	const [persistedFilters, setPersistedFilters] = useState<CustomFilterCategory[]>([]);
	const [selectedFilterOptions, setSelectedFilterOptions] = useState<number | null>();
	const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
	const [anchorElFilter, SetAnchorElFilter] = useState<Element | null>(null)
	const [ShowFilterOptions, SetShowFilterOptions] = useState<boolean>(false)
	const [addGroup, setAddGroup] = useState<boolean>(false);
	const [selectedGroup, setSelectedGroup] = useState<Group>();
	const [searchValue, setSearchValue] = useState<any>("");
	const [isDeleteGroupChat, setIsDeleteGroupChat] = useState<boolean>(false)
	const customAttributeFieldData = useSelector(selector.customAttributeFields);
	const Conversations: ConversationModel[] = useSelector(selector.conversations);
	const IsContactSyncing = useSelector(selector.IscontactsSyncing)
	const phoneNumbers: string[] = (Conversations ?? []).map(conversation => UtilityService.unmaskPhoneNumber(conversation.PhoneNumber));

	const ExportContactHeaders = [
		{ label: "FirstName", value: "FirstName" },
		{ label: "LastName", value: "LastName" },
		{ label: "PhoneNumber", value: "PhoneNumber" },
		{ label: "Email", value: "Email" },
		{ label: "Contacts Owner", value: "CreatedById" },
		{ label: "Updated By", value: "UpdatedById" },
		{ label: "Source", value: "Source" }
	]

	const getPhoneNumber = (id: string) => {
		return UtilityService.maskPhoneNumberOnLength(id);
	}

	const customAttributeColumns: ColDef[] = useMemo(
		() =>
			customAttributeFieldData.map((def) => ({
				field: `customAttr_${def.Reference}`,
				headerName: def.Name,
				valueGetter: (params: ValueGetterParams) => {
					const raw =
						params.data?.CustomAttributes?.find((ca: ContactCustomAttribute) => ca.reference === def.Reference)?.value ?? "";
					if (def.Type !== 4) return raw;
					const opt = def.OptionsDetail?.find((o) => o.id === raw);
					return opt?.label ?? raw;
				},
				hide: IsMobileDevice,
				minWidth: 120,
				resizable: true,
				cellStyle: { textOverflow: "ellipsis", paddingTop: "15px" },
			})),
		[customAttributeFieldData, IsMobileDevice]
	);

	const ContactsColoumnDefs: ColDef[] = [
		{
			field: "FirstName",
			headerName: "Name",
			valueGetter: (params: ValueGetterParams) => {
				return IsMobileDevice
					? params.data.LastName
						? UtilityService.replaceSpacesWithNBSP(UtilityService.trimMessage(`${params.data.FirstName} ${params.data.LastName}`, 30))
						: UtilityService.replaceSpacesWithNBSP(params.data.FirstName)
					: UtilityService.replaceSpacesWithNBSP(`${params.data.FirstName} ${params.data.LastName ? params.data.LastName : ""}`);
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				const id = UtilityService.unmaskPhoneNumber(params.data.PhoneNumber);
				const isPhoneNumberInList = phoneNumbers.includes(id);
				const WrappedComponent = {
					component: (props: any) => {
						const avatarElement = (
							<AvatarRenderer
								{...props}
								SetName={params.data.FirstName + " " + params.data.LastName}
								ShowBadgeIcon={false}
								HideAvatar={IsMobileDevice}
								PhoneNumber={params.data.PhoneNumber}
							/>
						);

						if (isPhoneNumberInList) {
							return (
								<Tooltip title="View Conversation History">
									<Link
										to={AppRoutes.CONVERSATION_HISTORY.replace(":id", id)}
										className="f-link-hover"
									>
										{avatarElement}
									</Link>
								</Tooltip>
							);
						}

						return (
							<Tooltip title="View Conversation History">
								<Link
									to={AppRoutes.CONVERSATIONS}
									state={params.data}
									className="f-link-hover"
								>
									{avatarElement}
								</Link>
							</Tooltip>
						);
					}
				};

				if (params.data) {
					return WrappedComponent;
				}

				return undefined;
			},
			headerCheckboxSelection: IsMobileDevice ? false : true,
			checkboxSelection: IsMobileDevice ? false : true,
			wrapText: IsMobileDevice ? true : false,
			autoHeight: IsMobileDevice ? true : false,
			resizable: true,
			cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "5px" } : { display: "flex" },
			minWidth: IsMobileDevice ? null : 200,
		},
		{
			field: "MaskedPhoneNumber",
			headerName: "Phone Number",
			valueFormatter: (params) => {
				return getPhoneNumber(params.data.MaskedPhoneNumber)
			},
			valueGetter: (params: ValueGetterParams) => {
				const raw =
					params.data?.PhoneNumber ||
					params.data?.MaskedPhoneNumber ||
					"";
				return `${raw} ${getPhoneNumber(raw)} ${raw.replace(/\D/g, "")}`;
			},
			cellRenderer: (params: ICellRendererParams) => {
				const id = UtilityService.unmaskPhoneNumber(params.data.PhoneNumber);
				const isPhoneNumberInList = phoneNumbers.includes(id);
				return (
					<>

						{isPhoneNumberInList ? (
							<Tooltip title="View Conversation History">
								<Link to={AppRoutes.CONVERSATION_HISTORY.replace(":id", id)} className="f-link-hover">
									{params.data.MaskedPhoneNumber}
								</Link>
							</Tooltip>
						) :
							<Tooltip title="View Conversation History">
								<Link to={AppRoutes.CONVERSATIONS} state={params.data} className="f-link-hover">
									{params.data.MaskedPhoneNumber}
								</Link>
							</Tooltip>
						}

					</>)
			},
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? 120 : 150,
			width: IsMobileDevice ? 120 : 150,
			maxWidth: IsMobileDevice ? 120 : 150,
		},
		{
			field: "Email",
			headerName: "Email",
			hide: IsMobileDevice,
			cellRenderer: params =>
				<span onClick={(e) => e.stopPropagation()} className={`color-grid-link c-pointer`} >
					<a href={`mailto:${params.data.Email || ''}`}>{params.data.Email || ''}</a>
				</span>,
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			minWidth: 170,
		},
		...customAttributeColumns,
		{
			field: "Groups",
			headerName: "Groups",
			hide: IsMobileDevice,
			valueGetter: (params) =>
				params.data.Groups?.map(group => group.Name).join(", ") || "",
			cellRenderer: params =>
				<div className="d-flex align-center">
					{params.data.Groups?.slice(0, 4).map((x, index) => (
						<Tooltip key={index} title={x.Name} placement="top">
							<span className='c-pointer mrn-1'>
								<Avatar Name={x.Name} Size={28} />
							</span>
						</Tooltip>
					))}

					{params.data.Groups?.length > 4 && (
						<Tooltip
							placement="right-start"
							title={(params.data.Groups?.slice(4)?.map((group, index) => {
								return <div className='h4-regular'>{group?.Name}</div>
							}))}
						>
							<span className="ml-2 br-5 w-4 h-4 d-flex align-center justify-center bg-color-secondary-btn-highlight-hover c-pointer">+{params.data.Groups?.length - 4}</span>
						</Tooltip>
					)}
				</div>,
			minWidth: 80
		},
		// {
		// 	field: "CreatedById",
		// 	headerName: "Contacts Owner",
		// 	hide: IsMobileDevice,
		// 	cellRenderer: params => {
		// 		return params.data.CreatedById === null ? "" : Allusers.find(x => x.ID === params.data.CreatedById)?.FirstName + " " + Allusers.find(x => x.ID === params.data.CreatedById)?.LastName
		// 	},
		// 	cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		// 	minWidth: 100,
		// 	valueGetter: (params: ValueGetterParams) => {
		// 		return params.data.CreatedById === null ? "" : Allusers.find(x => x.ID === params.data.CreatedById)?.FirstName + " " + Allusers.find(x => x.ID === params.data.CreatedById)?.LastName
		// 	},
		// },
		{
			field: "UpdatedById",
			headerName: "Updated By",
			hide: IsMobileDevice,
			cellRenderer: params => params.data.UpdatedById === null ? "" : Allusers.find(x => x.ID === params.data.UpdatedById)?.FirstName + " " + Allusers.find(x => x.ID === params.data.UpdatedById)?.LastName,
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			minWidth: 100,
			valueGetter: (params: ValueGetterParams) => {
				return params.data.UpdatedById === null ? "" : Allusers.find(x => x.ID === params.data.UpdatedById)?.FirstName + " " + Allusers.find(x => x.ID === params.data.UpdatedById)?.LastName
			}
		},
		{
			field: "Source",
			headerName: "Source",
			hide: IsMobileDevice,
			headerComponentParams: {
				template: selectedFilterTypes.includes("Source") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			cellRenderer: params => params.data.Source || '',
			// cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			minWidth: IsMobileDevice ? 100 : 100,
			width: IsMobileDevice ? 100 : 100,
			maxWidth: IsMobileDevice ? 100 : 100,
		},
		{
			field: "IsBlocked" || "IsUnsubscribed",
			headerName: "Status",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.IsUnsubscribed ? "Unsubscribed" : params.data.IsBlocked ? "Blocked" : "Active";
			},
			headerComponentParams: {
				template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				if (params.data) {
					const label = params.data.IsUnsubscribed ? "Unsubscribed" : params.data.IsBlocked ? "Blocked" : "Active";
					const variant = params.data.IsUnsubscribed ? GridStatusLabelVariant.Warning : params.data.IsBlocked ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Active;
					const Status = {
						component: StatusRenderer,
						params: {
							Variant: variant, Label: label, Id: params.data.ID
						}
					}
					return Status
				}
				return undefined
			},
			suppressSizeToFit: true,
			minWidth: 120,
			width: 120,
			maxWidth: 120
		},
		{
			field: "CreatedDateTime",
			headerName: "Updated Date",
			valueFormatter: (params: ValueFormatterParams) => {
				return UtilityService.convertDateToDay(params.value).toString()
			},
			// valueGetter: (params: ValueGetterParams) => {
			// 	return UtilityService.convertDateToDay(params.data.CreatedDateTime).toString()
			// },
			sort: !IsMobileDevice ? 'desc' : null,
			hide: IsMobileDevice,
			comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
			minWidth: 150,
			width: 150,
			maxWidth: 150,
			suppressSizeToFit: true
		},
		{
			field: "Action",
			maxWidth: 40,
			headerName: "",
			pinned: "right",
			lockPinned: true,
			lockPosition: "right",
			cellClass: "ag-cell-actions-style",
			headerClass: "bg-color-secondary",
			cellRenderer: params =>
				<ActionsRenderer
					MenuData={getMenuActions(params.data)}
					{...params}
				/>,
			resizable: false,
			sortable: false,
			hide: IsMobileDevice,
		},
	]

	const getMenuActions = (data: Contact) => {
		return [
			{
				Name: ActionLabels.EDIT,
				Icon: EditContactIcon,
				Hide: data?.IsUnsubscribed,
				OnClick: () => openEditContact(data as Contact),
			},
			{
				Name: ActionLabels.SEND,
				Icon: SendIcon,
				Hide: data?.IsUnsubscribed,
				OnClick: () => onSendmessage((data as Contact).ID),
			},

			{
				Name: ActionLabels.SHARE,
				Icon: ShareContactIcon,
				OnClick: () => openShareContactDialog((data as Contact).ID),
			},
			{
				Name: ActionLabels.DELETE,
				Icon: TrashIcon,
				OnClick: () => openConfirmDialog((data as Contact).ID || ""),
			},
			{
				Name: !!data?.IsBlocked ? ActionLabels.UNBLOCK : ActionLabels.BLOCK,
				Icon: BlockIcon,
				OnClick: () => openBlockConfirmDialog((data as Contact).ID, (data as Contact).IsBlocked),
			},
		]
	}


	const initialFilterOptions = () => {
		const filterData: CustomFilterCategory[] = [
			{
				Id: 1,
				Title: "Status",
				IsSelectedAll: false,
				Options: _(Contacts)
					.map(row => {
						return {
							Key: "ContactStatus",
							Id: row.ID,
							Label: row.IsUnsubscribed ? "Unsubscribed" : row.IsBlocked ? "Blocked" : "Active",
							Value: row.ContactStatus,
							IsSelected: false
						};
					})
					.uniqBy('Label')
					.value()
			},
			{
				Id: 2,
				Title: "Source",
				IsSelectedAll: false,
				Options: _(Contacts)
					.map(row => {
						return {
							Key: "Source",
							Id: row.ID,
							Label: row.Source,
							Value: row.Source,
							IsSelected: false
						};
					})
					.uniqBy('Label')
					.value()
			},
		];

		setFilterOptions(filterData);
	};

	const handleApplyFilters = (filters: CustomFilterCategory[]) => {
		setFilterOptions(filters);
		const { result } = UtilityService.getFilterTypes(filters);
		setSelectedFilterTypes(result)
	};

	useEffect(() => {
		initialFilterOptions()
	}, [Contacts, appliedfilters])

	const resetFilters = () => {
		setFilterOptions([])
		setappliedfilters([])
		setPersistedFilters([])
		setSelectedFilterOptions(null)
		setSelectedFilterTypes([])
		initialFilterOptions()
	}

	const handleCloseFilter = () => {
		SetAnchorElFilter(null);
		SetShowFilterOptions(false);
	}

	const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
		SetAnchorElFilter(event.currentTarget);
	}

	useEffect(() => {
		LoadSettings(dispatch);
		if (Groups.length === 0) {
			LoadGroups(dispatch);
		}
		if (Contacts.length === 0) {
			LoadContacts(dispatch);
		}
		if (CustomAttributeDefinitions.length === 0) {
			LoadCustomAttributeDefinitions(dispatch)
		}
		// SettingsService.getSettingByCode(SettingsService.Group_Contacts_Code).then(
		// 	(res) => {
		// 		if (!!res)
		// 			setGroupContactCount(parseInt(res.value) || 0)
		// 	}
		// );
		LoadUsers(dispatch)

		return () => {
			setSelectedCount(0)
		}
	}, []);

	useEffect(() => {
		setHeaderTitle(pageTitles.CONTACTS);
		setHeaderCount(Contacts?.length || 0)
		setRefreshHandler(gridRefresh)
		return setHeaderTitle
	}, [gridApi, columnApi])

	useEffect(() => {
		clearSelection()
		setHeaderCount(Contacts?.length || 0)
		setSelectedCount(0)
	}, [Contacts])

	const gridRefresh = () => {
		resetFilters()
		LoadContacts(dispatch);
		if (!!columnApi) {
			columnApi.resetColumnState()
		}

		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
			gridApi.deselectAll();
		}
		setShowMultiActionButtons(false);
		setCheckedContacts([]);
	}

	const openBlockConfirmDialog = (rowId: string, isBlocked: boolean) => {
		let text = isBlocked ? appNote.UNBLOCK_CONTACT : appNote.BLOCK_CONTACT;
		setShow(true);
		setClickRowId(rowId);
		setText(text);
		setDialogAction("Blocked");
		setButtonName(isBlocked ? "Unblock" : "Block");
		setMobileMenu(false);
		setIsLoading(false);
	}

	const openConfirmDialog = (rowId: string) => {
		setShow(true);
		setClickRowId(rowId);
		setText(appNote.CONTACT_DELETE);
		setDialogAction("Delete");
		setButtonName("Delete");
		setMobileMenu(false);
		setIsLoading(false);
	}

	const closeConfirmDialog = (isConfim: boolean) => {
		var action = dialogAction;
		if (!!isConfim && (action === "Delete" || action === "Blocked")) {
			setIsLoading(true);
			let row = Contacts.find((x) => x.ID === clickRowId);
			let Name = row ? (row.Name ? row.Name : row.PhoneNumber) : "";
			var apiCall =
				action === "Delete"
					? ContactService.deleteContact(clickRowId, isDeleteGroupChat)
					: ContactService.blockUnBlockNumber(
						row?.PhoneNumber,
						!row?.IsBlocked
					);
			apiCall.then((res) => {
				action === "Delete"
					? setToast(
						ToasterTexts.CONTACT_DELETE_SUCCESS.replace("<Name>", Name),
						ToasterType.SUCCESS
					)
					: setToast(
						!row?.IsBlocked
							? ToasterTexts.CONTACT_BLOCK_SUCCESS.replace("<Name>", Name)
							: ToasterTexts.CONTACT_UNBLOCK_SUCCESS.replace("<Name>", Name),
						ToasterType.SUCCESS
					);
				if (action === "Delete") {
					LoadMessages(dispatch)
				}
				// gridRefresh()
				setShow(false);
				setMobileMenu(false);
				setClickRowId("");
				setContactToEdit(undefined);
				setIsLoading(false);
				setCheckedContacts([]);
				clearSelection()
				setIsDeleteGroupChat(false)
			});
		}
		else {
			setShow(false);
			setMobileMenu(false);
			setClickRowId("");
			setContactToEdit(undefined);
			setIsLoading(false);
			setIsDeleteGroupChat(false)
		}
	};

	const openShareContactDialog = (id: string) => {
		let row = Contacts.find((x) => x.ID === id);
		if (row) {
			setOpenShareContact(true);
			setContactName(`${ActionLabels.SHARE_THIS_CONTACT}-${IsMobileDevice ? UtilityService.trimMessage(row.Name, 17) : row.Name}`.trim())
			setMobileMenu(false);
			setShareContactId([row.ID]);
		}
	}

	const closeShareContactDialog = () => {
		setOpenShareContact(false);
		setShareContactId([]);
	}

	const handleShareContact = (phoneNumberIDs: string[]) => {
		setShareContactLoading(true);
		let data = {
			contactIdList: shareContactId,
			phoneIdList: phoneNumberIDs
		}
		ContactService.shareContact(data).then(res => {
			setToast(checkedContacts?.length > 1 ? `${ToasterTexts.CONTACT_SHARED_SUCCESSFULLY.replace("Contact", "Contacts")}` : ToasterTexts.CONTACT_SHARED_SUCCESSFULLY, ToasterType.SUCCESS)
			setOpenShareContact(false);
			setShareContactLoading(false);
			setCheckedContacts([]);
			setShowMultiActionButtons(false);
			clearSelection();
		}).catch(err => {
			setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
			setOpenShareContact(false);
			setShareContactLoading(false);
			setCheckedContacts([]);
			setShowMultiActionButtons(false);
		});
	}

	const openEditContact = (contact?: Contact) => {
		setShowEdit(true);
		setContactToEdit(contact);
		setMobileMenu(false);
		setClickRowId("");
	}

	const closeEditContact = (isConfim: boolean) => {
		setShowEdit(false);
		setContactToEdit(undefined);
		setMobileMenu(false);
		setClickRowId("");
		resetFilters()
	};

	const onSendmessage = (id: string) => {
		let row = Contacts.find((x) => x.ID === id);
		if (row) {
			setContactName(row.Name || `${row.FirstName} ${row.LastName}`.trim())
			setContactID(row.ID);
			setMobileMenu(false);
			setOpen(true);
			setClickRowId("");
			setContactToEdit(undefined);
		}
	};

	const closeSendmessage = (success?: boolean) => {
		setContactID("");
		setMobileMenu(false);
		setOpen(false);
		setClickRowId("");
		setContactToEdit(undefined);
		if (success) {
			setCheckedContacts([]);
			clearSelection();
		}
	};

	const getGridTitle = () => {
		if (showMultiActionButtons) {
			if (checkedContacts && checkedContacts.length > 1) {
				return checkedContacts.length + " Items selected";
			} else if (checkedContacts && checkedContacts.length === 1) {
				return "1 Item selected";
			}
		}
		else {
			if (Contacts?.length === 1) {
				return "1 Contact"
			}
			else {
				return Contacts?.length + " " + pageTitles.CONTACTS
			}
		}
	}

	const onClickGroup = () => {
		setAddGroup(true);
	};

	const closeGroup = () => {
		setAddGroup(false);
	}

	useEffect(() => {
		if (!IsMassDeletionInProgress) {
			setCheckedContacts([])
			setShowMultiActionButtons(false)
			localStorage.removeItem("contactMassAction")
		}
	}, [IsMassDeletionInProgress])


	const multipleSendmessage = () => {
		setOpen(true);
	};

	const onGridReady = (params) => {
		setGridApi(params.api)
		SetColumnApi(params.columnApi)
	}

	const onSelectionChanged = () => {
		let SelectedContacts: Contact[] = gridApi.getSelectedRows()
		if (gridApi && SelectedContacts.length > 0) {
			setShowMultiActionButtons(true);
			setCheckedContacts(SelectedContacts);
			setSelectedCount(SelectedContacts.length)
		}
		else {
			setShowMultiActionButtons(false);
			setCheckedContacts([])
			setSelectedCount(SelectedContacts.length)
		}
	}

	const globalSearch = (e: any) => {
		setSearchValue(e.target.value)
		gridApi.setQuickFilter(e.target.value)
	};

	const handleOpenImport = () => {
		// props.history.push(AppRoutes.IMPORT_CONTACTS);
		navigate(AppRoutes.IMPORT_CONTACTS)
	};

	const handleOpenCustomAttributes = () => {
		navigate(AppRoutes.CUSTOM_ATTRIBUTES)
	};

	const handleOpenDownloadContacts = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleCloseDownloadContacts = () => {
		setAnchorEl(null);
	}

	const openMassActionConfirmDialog = (action: string) => {
		let text = action === ContactsMassAction.BLOCK ? appNote.MASS_ACTION_TEXT.replace('<action>', ContactsMassAction.BLOCK).replace('<name>', checkedContacts.length > 1 ? pageTitles.CONTACTS.toLocaleLowerCase() : ContactsMassAction.CONTACT) : appNote.MASS_ACTION_TEXT.replace('<action>', ContactsMassAction.UNBLOCK).replace('<name>', checkedContacts.length > 1 ? pageTitles.CONTACTS.toLocaleLowerCase() : ContactsMassAction.CONTACT)
		setOpenMassAction(true);
		setText(text);
		setButtonName(action);
		setMobileMenu(false);
		setIsLoading(false);
	}

	const closeMassActionConfirmDialog = (isConfim: boolean) => {
		if (!!isConfim) {
			setIsLoading(true);
			if (buttonName === ContactsMassAction.DELETE) {
				var data = checkedContacts?.map((item) => {
					return item.ID
				})
			}
			else {
				var data = checkedContacts?.map((item) => {
					return item.PhoneNumber
				})
			}
			const MassActioninfo = {
				ButtonName: buttonName,
				selectedConversations: data.length
			}
			ContactService.contactsMassActionDelete(buttonName, data).then((res) => {
			}).catch(err => {
				if (err?.response.status === 404 || err?.response.status === 400 || err?.response.status === 500) {
					setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
					setIsLoading(false);
				}
				UpdateContactsMassActionDeletionStatus(dispatch, false)
			})

			localStorage.setItem("contactMassAction", JSON.stringify(MassActioninfo))
			if (buttonName === ContactsMassAction.DELETE) {
				setToast("Attention: Your contacts are currently being deleted in the background. Feel free to continue using the application.", ToasterType.INFO)
			}
			else if (buttonName === ContactsMassAction.BLOCK) {
				setToast("Attention: Your contacts are currently being blocked in the background. Feel free to continue using the application.", ToasterType.INFO)
			}
			else {
				setToast("Attention: Your contacts are currently being unblocked in the background. Feel free to continue using the application.", ToasterType.INFO)
			}

			setOpenMassAction(false);
			setButtonName("");
			setMobileMenu(false);
			setIsLoading(false);
			setCheckedContacts([]);
			setShowMultiActionButtons(false);
			clearSelection();
			UpdateContactsMassActionDeletionStatus(dispatch, true)
		}
		else {
			setOpenMassAction(false);
			setButtonName("");
			setMobileMenu(false);
			setIsLoading(false);
		}
	};

	const openMassActionShareContactDialog = () => {
		let name = checkedContacts?.length > 1 ? `${ActionLabels.SHARE_THIS_CONTACT.replace("this", "these").replace("Contact", "Contacts")}` : `${ActionLabels.SHARE_THIS_CONTACT}-${IsMobileDevice ? UtilityService.trimMessage(checkedContacts[0].Name, 17) : checkedContacts[0].Name}`
		setOpenShareContact(true);
		setContactName(name);
		setShareContactId(checkedContacts?.map(x => x.ID));
	}

	const clearSelection = () => {
		if (!!gridApi && (!!checkedContacts?.length))
			gridApi.deselectAll();
	}

	const closeMenu = () => {
		setMobileMenu(false);
	};

	const handleRowClick = (row: Contact) => {
		if (IsMobileDevice) {
			setMobileMenu(true);
			setContactToEdit(row);
		}

	}

	const pullToRefresh = () => new Promise((resolve) => resolve).then(() => LoadContacts(dispatch))

	const massAction = JSON.parse(localStorage.getItem("contactMassAction"))
	const getContacts = (contacts: Contact[]): Contact[] => {
		const downloadContacts = contacts.map((contact) => {
			const fullNameCreadteBy = contact.CreatedById === null ? "" : (Allusers.find(x => x.ID === contact.CreatedById)?.FirstName || "") + " " + (Allusers.find(x => x.ID === contact.CreatedById)?.LastName || "");
			const fullNameUpdatedBy = contact.UpdatedById === null ? "" : Allusers.find(x => x.ID === contact.UpdatedById)?.FirstName || "" + " " + Allusers.find(x => x.ID === contact.UpdatedById)?.LastName || ""
			return {
				...contact,
				CreatedById: fullNameCreadteBy,
				UpdatedById: fullNameUpdatedBy
			};
		});
		return downloadContacts;
	}

	const handleCellRowClick = (e: any, row: Contact) => {
		if (!IsMobileDevice && (e.colDef.field !== "Action" && e.colDef.field !== "MaskedPhoneNumber" && e.colDef.field !== "FirstName")) {
			openEditContact(row)
		}
	}

	return (
		showEdit && IsMobileDevice ? (
			<ContactViewComponent
				onClose={closeEditContact}
				show={showEdit}
				Contact={contactToEdit}
				clearSelection={clearSelection}
			/>
		) : open && IsMobileDevice ? (
			<SendMessage
				open={open}
				// contactName={contactName ? [contactName] : checkedContacts?.map((x) => x.Name)}
				ContactIDs={contactID ? [contactID] : checkedContacts?.map((x) => x.ID)}
				handleClose={closeSendmessage}
			/>
		) : IsMobileDevice && Boolean(anchorElFilter) ? (<FilterComponent
			Filters={filterOptions}
			HandleApplyFilters={handleApplyFilters}
			OnClose={handleCloseFilter}
		/>) :
			<PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>

				<div className="d-flex flex-direction h-p-100 o-hidden justify-between contact-container">
					{!IsMobileDevice ?
						<div>
							<PageHeaderComponent
								HandleFilter={handleClickFilter}
								IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
								Reload={() => LoadContacts(dispatch)}
								GridTitle={""}
								Count={Contacts.length}
								Actions={
									!IsMobileDevice ? [
										{
											OnClick: () => openEditContact(undefined),
											ButtonLabel: buttonLabels.ADD_CONTACT,
											Icon: AddContactIcon,
											ClassName: "mr-2",
											Variant: (IsMassDeletionInProgress || IsContactSyncing) ? "disabled-btn" : "primary-btn",
										},
										{
											OnClick: () => handleOpenImport(),
											ButtonLabel: buttonLabels.IMPORT_CONTACTS,
											Icon: (IsMassDeletionInProgress || IsContactSyncing) ? AddContactIcon : IsDarkMode ? AddContactIcon : ImportContactIcon,
											ClassName: "mr-2",
											Variant: (IsMassDeletionInProgress || IsContactSyncing) ? "disabled-btn" : "secondary-btn",
										},
										{
											OnClick: () => handleOpenCustomAttributes(),
											ButtonLabel: buttonLabels.CUSTOM_ATTRIBUTES,
											ClassName: "mr-2",
											Variant: (IsMassDeletionInProgress || IsContactSyncing) ? "disabled-btn" : "secondary-btn",
										},
										{
											OnClick: () => {
												exportToExcel(ExportContactHeaders, getContacts(Contacts), `FalkonSMS-Export-Contacts-${moment(UtilityService.getPreferredTimeZoneTimeNow(), ["MM-DD-YYYY"]
												).format("MM-DD-YYYY")}`, ToasterTexts.EXCEL_EXPORT_CONTACT_MESSAGE); handleCloseDownloadContacts()
											},
											ButtonLabel: "",
											Icon: !IsMassDeletionInProgress ? DownloadedIcon : DisableHorizontalIcon,
											Variant: (IsMassDeletionInProgress || IsContactSyncing) ? "disabled-btn" : "secondary-btn",
										}
									] : [
										{
											OnClick: () => openEditContact(undefined),
											ButtonLabel: buttonLabels.ADD_CONTACT,
											Icon: AddContactIcon,
											ClassName: "mr-2",
											Variant: "primary-btn",
										},
									]}
								ShowFilterIcon={true}
								searchValue={searchValue}
								onSearch={(e) => globalSearch(e)}
								PlaceHolder={"Search ..."}
								ShowMultiActionButtons={showMultiActionButtons}
								MultiActionButtons={[
									{
										Name: ActionLabels.SEND,
										Variant: !IsMassDeletionInProgress && !!checkedContacts?.length ? "primary" : "disabled",
										Hide: checkedContacts?.length > (Number(Settings?.find(x => x.Code === SettingsService.Message_Contacts_Code)?.Value) || 0) || !checkedContacts?.length || checkedContacts?.filter(x => x.IsUnsubscribed)?.length > 0,
										ClassName: "mr-1",
										Icon: MultiSelectSendIcon,
										OnClick: () => multipleSendmessage()
									},
									{
										Name: ActionLabels.GROUP,
										Variant: !IsMassDeletionInProgress && !!checkedContacts?.length ? "primary" : "disabled",
										ClassName: "mr-1",
										Icon: MultiSelectGroupIcon,
										OnClick: () => onClickGroup(),
									},
									{
										Name: ActionLabels.SHARE,
										Variant: !IsMassDeletionInProgress && !!checkedContacts?.length ? "primary" : "disabled",
										ClassName: "mr-1",
										Icon: MultiSelectShareIcon,
										OnClick: () => openMassActionShareContactDialog(),
									},
									{
										Name: (!!checkedContacts?.length && checkedContacts?.every(item => item.IsBlocked)) ? ActionLabels.UNBLOCK : (!!checkedContacts?.length && checkedContacts?.every(item => !item.IsBlocked)) ? ActionLabels.BLOCK : ActionLabels.BLOCK,
										Variant: !IsMassDeletionInProgress && ((!!checkedContacts?.length && checkedContacts?.every(item => item.IsBlocked)) || (!!checkedContacts?.length && checkedContacts?.every(item => !item.IsBlocked))) ? "primary" : "disabled",
										Hide: !((!!checkedContacts?.length && checkedContacts?.every(item => item.IsBlocked)) || (!!checkedContacts?.length && checkedContacts?.every(item => !item.IsBlocked))),
										ClassName: "mr-1",
										Icon: (!!checkedContacts?.length && checkedContacts?.every(item => item.IsBlocked)) ? MultiSelectUnblockIcon : (!!checkedContacts?.length && checkedContacts?.every(item => !item.IsBlocked)) ? MultiSelectBlockIcon : MultiSelectBlockIcon,
										OnClick: () => checkedContacts.length === 1 ? openBlockConfirmDialog(checkedContacts[0]?.ID, checkedContacts[0]?.IsBlocked) : openMassActionConfirmDialog(checkedContacts.every(item => item.IsBlocked) ? ContactsMassAction.UNBLOCK : ContactsMassAction.BLOCK)
									},
									{
										Name: ActionLabels.DELETE,
										Variant: !IsMassDeletionInProgress && !!checkedContacts?.length ? "primary" : "disabled",
										ClassName: "mr-1",
										Icon: MultiSelectDeleteIcon,
										OnClick: () => checkedContacts.length === 1 ? openConfirmDialog(checkedContacts[0].ID || "") : openMassActionConfirmDialog(ContactsMassAction.DELETE)
									},
									{
										Name: ActionLabels.CLEAR_SELECTION,
										Variant: "text",
										ClassName: "p-0 mr-1 w-space",
										Icon: MultiSelectCrossIcon,
										OnClick: () => clearSelection(),
									}
								]}
							/>
						</div> :
						<Grid className={``} >
							<PageHeaderComponent
								IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
								Reload={() => LoadContacts(dispatch)}
								GridTitle={getGridTitle()}
								Count={Contacts.length}
								Actions={[{
									OnClick: () => openEditContact(undefined),
									ButtonLabel: buttonLabels.ADD_CONTACT,
									ClassName: "mr-2",
									Variant: "primary-btn",
								}]}
								ShowFilterIcon={true}
								HandleFilter={handleClickFilter}
								onSearch={globalSearch}
								PlaceHolder={"Search ..."}
							/>
						</Grid>
					}
					{IsMassDeletionInProgress && <div className='px-3 h6-semibold my-auto d-flex'> <TimmerIcon className="mr-1" /><div className=''>
						{`Contact ${massAction?.ButtonName === ContactsMassAction.DELETE ? "Deletion" : massAction?.ButtonName === ContactsMassAction.BLOCK ? "Blocking" : "Unblocking"} In Progress. You can continue using the application while your contacts are being updated.`}</div>
					</div>}
					{IsContactSyncing && <div className='px-3 h6-semibold my-auto d-flex'> <TimmerIcon className="mr-1" /><div className=''>
						{`Contact Syncing Is In Progress. You can continue using the application while your contacts are being updated.`}</div>
					</div>}
					<GridComponent
						ColumnDefs={ContactsColoumnDefs}
						IsPaginationEnabled={IsMobileDevice ? false : true}
						OnGridReady={onGridReady}
						RowData={!!selectedFilterOptions ? !!appliedfilters.length ? appliedfilters : [] : Contacts}
						OnSelectionChanged={onSelectionChanged}
						OnGridRowClick={handleRowClick}
						EmptyLabel={emptyLabels.CONTACTS}
						LockVisible={IsMobileDevice}
						filterOptions={filterOptions}
						IsFilterPresent={true}
						gridApi={gridApi}
						OnGridCellRowClick={handleCellRowClick}
						ShowRowPointer={true}
						isHorizontalScroll={true}
					/>
					{
						addGroup && !IsMobileDevice &&
						<Dialog
							onClose={closeGroup}
							aria-labelledby="responsive-dialog-title"
							open={true}
							BackdropProps={IsMobileDevice ? {} : {
								style: { backgroundColor: "transparent" },
							}}
							className={"dialogue-shadow h-p-100"}
							disableEscapeKeyDown
							PaperProps={{
								style: {
									height: "75vh",
									width: "100vh",
								},
							}}
						>
							<DialogTitle className="dialog-header" >
								<div className={`${IsMobileDevice ? 'h1' : 'h2-regular'} color-display-title d-flex ml-1`} id="customized-dialog-title">
									{DialogHeaders.ADD_GROUP}
									<Tooltip title="Close" placement="bottom">
										<span className="ml-auto mr-1">
											<CancelIcon
												className={"c-pointer"}
												onClick={closeGroup}
											/>
										</span>
									</Tooltip>
								</div>
							</DialogTitle>
							<div className={"bb-primary-background-pink-4 mx-2"}></div>
							<EditGroupComponent
								{...selectedGroup}
								ContactsInGroup={checkedContacts}
								checkedContacts={checkedContacts}
								closeHandler={closeGroup}
								IsMobileDevice={IsMobileDevice}
								clearSelection={clearSelection}
							></EditGroupComponent>
						</Dialog>
					}
					{
						showEdit && !IsMobileDevice && (
							<ContactViewComponent
								onClose={closeEditContact}
								show={showEdit}
								Contact={contactToEdit}
								clearSelection={clearSelection}
							/>
						)
					}
					{
						open && !IsMobileDevice && (
							<SendMessage
								open={open}
								// contactName={contactName}
								ContactIDs={contactID ? [contactID] : checkedContacts?.map((x) => x.ID)}
								handleClose={closeSendmessage}
							/>
						)
					}
					{
						openShareContact &&
						<SelectPhoneNumbers
							Title={contactName}
							OnClose={closeShareContactDialog}
							Show={openShareContact}
							HandleSubmit={handleShareContact}
							Loading={shareContactLoading}
							ButtonName={buttonLabels.SHARE}
							Options={PhoneNumbers?.filter((x: PhoneNumberModel) => x.OrganizationID === CurrentUser?.OrgId && x.Status === PhoneNumberStatus.ACTIVE && CurrentUser?.PhoneNumber !== x.PhoneNumber)}
						/>
					}

					<ConfirmDialog
						onClose={closeConfirmDialog}
						Show={show}
						Text={dialogAction !== "Delete" && text}
						TextProps={() => dialogAction === "Delete" && <div>
							Following actions will happen (if any):<br />
							•	<b>Groups:</b> Contact gets deleted in the groups it is added<br />
							•	<b>Group Schedule messages:</b> Contact will not receive the group scheduled message<br />
							•	<b>Schedule messages:</b> This contact Phone Number will not receive the scheduled message if it is added individually.<br />
							<div className='d-flex mt-1'>
								<Checkbox
									name="checkbox"
									className="p-0"
									classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
									checked={isDeleteGroupChat}
									onChange={(e) => setIsDeleteGroupChat(e?.target.checked)}
								/>
								<span className='ml-1'> Do you want to delete the group chat associated with this contact?</span>
							</div>
							<p className="pt-1">Do you still want to delete this contact?</p>

						</div>}
						HideCancel={dialogAction === "Import"}
						ButtonName={buttonName}
						IsMobileDevice={IsMobileDevice}
						Loading={isLoading}
					></ConfirmDialog>

					{
						openMassAction &&
						<ConfirmDialog
							onClose={closeMassActionConfirmDialog}
							Show={openMassAction}
							Text={buttonName !== ContactsMassAction.DELETE && text}
							TextProps={() => buttonName === ContactsMassAction.DELETE && <div>
								Following actions will happen (if any):<br />
								•	<b>Groups:</b> Contact gets deleted in the groups it is added<br />
								•	<b>Group Schedule messages:</b> Contact will not receive the group scheduled message<br />
								•	<b>Schedule messages:</b> This contact Phone Number will not receive the scheduled message if it is added individually.<br />
								<p className="pt-1">Do you still want to delete {checkedContacts?.length > 1 ? "these contacts" : "this contact"}?</p>
							</div>}
							ButtonName={buttonName}
							IsMobileDevice={IsMobileDevice}
							Loading={isLoading}
						></ConfirmDialog>
					}

					{mobileMenu && IsMobileDevice && contactToEdit !== null && (
						<Dialog
							fullWidth
							onClose={closeMenu}
							aria-labelledby="responsive-dialog-title"
							open={true}
							classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
						>
							<DialogTitle className="dialog-header pb-1">
								<div className="h1 color-display-title d-flex" id="customized-dialog-title">
									{!!contactToEdit?.Name && UtilityService.trimMessage(contactToEdit?.Name, 12)}
									<span className="ml-auto">
										<Tooltip
											title="Close"
											placement="bottom"
											enterTouchDelay={0}
										>
											<CancelIcon
												className={"c-pointer"}
												onClick={(e: any) => {
													e.stopPropagation();
													closeMenu();
												}}
											/>
										</Tooltip>
									</span>
								</div>
							</DialogTitle>
							<DialogContent className={"mln-1 o-hidden pt-0"}>
								<MenuItemRenderer MenuData={getMenuActions(contactToEdit)} OnClick={closeMenu} />
							</DialogContent>
						</Dialog>
					)}

					{!IsMobileDevice && Boolean(anchorElFilter) &&
						<Popover
							open={Boolean(anchorElFilter)}
							anchorEl={anchorElFilter}
							onClose={handleCloseFilter}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
						>
							<FilterComponent
								Filters={filterOptions}
								HandleApplyFilters={handleApplyFilters}
								OnClose={handleCloseFilter}
							/>
						</Popover>
					}
				</div>
			</PullToRefresh>
	)
}

export default ContactsComponent;
